import { datadogRum } from "@datadog/browser-rum"

export default {
  report: (error, params = {}) => {
    datadogRum.addError(error, params)
  },
}
